<!-- <template>
  <div>
      <wx-open-launch-weapp
          id="launch-btn"
          appid="wx9c0de786e0f4e31d" path="pages/home/index/index.html"
          @launch="handleLaunch"
          @error="handleError"
      >
          <script type="text/wxtag-template">
              <style>.btn { padding: 12px; border: 1px solid red; }</style>
              <button class="btn">打开小程序</button>
          </script>
      </wx-open-launch-weapp>
  </div>
</template> -->
<template>
  <div class="pages">
    <img class="top_img" :src="Util.getImgUrl(images.top)" />
    <img class="logo_img2" :src="Util.getImgUrl(images.logo)" />
    <img class="left_img" :src="Util.getImgUrl(images.left)" />
    <img class="right_img" :src="Util.getImgUrl(images.right)" />
    <img class="type_img" :src="Util.getImgUrl(images.mine)" />
    <img class="nav_icon_img" :src="Util.getImgUrl(images.nav_icon)" @click="nav_show = true" />
    <div class="content">
      <div class="func_box" v-if="is_admin">
        <div class="func_margin">
          <div class="func_item">
            <img src="https://static.zhenhuixuan365.com/static/employ/images/mine_position.png" class="func_icon">
            <span class="func_name">岗位管理</span>
            <img src="https://static.zhenhuixuan365.com/static/employ/images/arrow.png" class="func_icon">
            <wx-open-launch-weapp id="launch-btn" appid="wx9c0de786e0f4e31d"
              path="packageA/pages/employ/positions/positions.html" @launch="handleLaunch" @error="handleError"
              style="position: absolute; top: 0; left: 0; width: 100%; height: 100%">
              <script type="text/wxtag-template">
                <div style=" width: 100%; height: 50px; display: flex; flex-direction: column; align-items: center; " ></div> 
                              </script>
            </wx-open-launch-weapp>
          </div>
          <div class="func_item">
            <img src="https://static.zhenhuixuan365.com/static/employ/images/mine_posts.png" class="func_icon">
            <span class="func_name">简历管理</span>
            <img src="https://static.zhenhuixuan365.com/static/employ/images/arrow.png" class="func_icon">
            <wx-open-launch-weapp id="launch-btn" appid="wx9c0de786e0f4e31d" path="packageA/pages/employ/posts/posts.html"
              @launch="handleLaunch" @error="handleError"
              style="position: absolute; top: 0; left: 0; width: 100%; height: 100%">
              <script type="text/wxtag-template">
                <div style=" width: 100%; height: 50px; display: flex; flex-direction: column; align-items: center; " ></div> 
                              </script>
            </wx-open-launch-weapp>
          </div>
        </div>
      </div>

      <div class="func_box" v-for="func in funcs" :key="func">
        <div class="func_margin">
          <button class="func_item" v-for="item in func" :key="item.icon" @click="onBtnClick(item)">
            <img class="func_icon" :src="Util.getImgUrl(images[item.icon])" />
            <span class="func_name">{{ item.name }} </span>
            <img class="func_icon" :src="Util.getImgUrl(images.arrow)" />
          </button>
        </div>
      </div>
    </div>

    <employNav :nav_show.sync="nav_show"></employNav>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import employNav from '../../components/employNav.vue'
import { Dialog } from 'vant'

export default {
  components: {
    employNav,
  },
  data() {
    return {
      nav_show: false,
      images: [],
      funcs: [],
      is_admin: false,
    }
  },
  mounted() {
    document.title = '中船航海人才招聘'
    this.loadData()
    var current_url = window.location.href.split('#')[0];
    this.$api.wechatJssdkConfig({
      url: current_url
    }).then(res => {
      console.log(res);
      wx.config({
        debug: false, // 开启调试模式,
        appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
        signature: res.data.signature, // 必填，签名，见附录1
        jsApiList: [
          "checkJsApi",
          "openLocation",
          "getLocation",
          "closeWindow",
          "scanQRCode",
          "chooseWXPay",
          "chooseImage",
          "uploadImage",
          "previewImage",
          "getLocalImgData"
        ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        openTagList: ['wx-open-launch-weapp']  // 这里要配置一下
      });
    }).catch(e => {
      console.log(e);
    })
    wx.ready(function () {
      console.log('wx.ready');
    })
  },
  methods: {
    loadData() {
      let that = this
      that.$api.employMine({}).then(res => {
        // that.Util.wechatShare(res.data.share)
        that.images = res.data.images
        that.funcs = res.data.funcs
        that.is_admin = res.data.is_admin
      })
    },
    handleError(e) {
      console.log("error", e, e.detail);
    },
    handleLaunch(e) {
      console.log("success", e, e.detail);
    },
    onBtnClick(obj) {
      console.log(123, obj);
      if (obj.path) {
        this.$router.push({ name: obj.path.name })
      } else if (obj.alert) {
        Dialog.alert({
          title: '提示',
          message: obj.alert,
          confirmButtonColor: '#00428e'
        })
      }
    }
  }
}
</script>
<style scoped src="./employ.css"></style>
<style scoped src="./mine.css"></style>
      